// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rdg-light {
  font-family: sans-serif;
  font-size: 14px;
}

.rdg-cell {
  padding: 8px;
  border: 1px solid #ddd;
}

.rdg-editor-container {
  display: block;
  width: 100%;
  height: 100%;
}

.react-datasheet-grid-header {
  display: flex !important;
  opacity: 1 !important;
  visibility: visible !important;
}
`, "",{"version":3,"sources":["webpack://./src/PipelineConfig.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,8BAA8B;AAChC","sourcesContent":[".rdg-light {\n  font-family: sans-serif;\n  font-size: 14px;\n}\n\n.rdg-cell {\n  padding: 8px;\n  border: 1px solid #ddd;\n}\n\n.rdg-editor-container {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.react-datasheet-grid-header {\n  display: flex !important;\n  opacity: 1 !important;\n  visibility: visible !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
